<template>
  <!-- 添加商品组件 -->
  <van-popup z-index="1000" v-model:show="showBottom" @closed="close" id="additiveproduct" position="bottom">
    <div class="main">
      <!-- 标题 -->
      <div class="top-box">
        <div class="title">

          <span :class="{ active: active == 1 }" @click="active = 1, shoptype = 'cart', getorderAddGoodsList()">{{
            $fanyi('购物车') }}</span>
          <span :class="{ active: active == 2 }" @click="active = 2, shoptype = 'inventory', getorderAddGoodsList()"> {{
            $fanyi('商品库') }}</span>


        </div>
        <van-icon @click="showBottom = false" name="cross" />
      </div>
      <!-- 购物车 -->
      <div class="cart" v-if="active == 1">
        <!-- 列表 -->

        <div v-if="cartlist.length > 0">
          <!-- 商品信息 -->
          <div class="gooditem" :class="{ borderbottom: index != 0 }" v-for="(goodsitem, index) in cartlist"
            :key="goodsitem.goods_id">
            <div class="Content">
              <!--复选框 -->
              <input class="checkbox-box" @change="cartcheckchange(item)" type="checkbox" v-model="goodsitem.checked" />
              <!-- 图片 -->
              <div class="img-box" @click="$fun.toCommodityDetails({
                goods_id: goodsitem.goods_id,
                shop_type: goodsitem.shop_type,
              }
              );">
                <van-image :src="goodsitem.pic">
                  <template v-slot:loading>
                    <van-loading type="spinner" size="20" />
                  </template>
                </van-image>
              </div>
              <!--右侧商品信息  -->
              <div class="rightgoodsinfo">
                <!-- 商品描述和删除 -->
                <div class="Description">
                  <p class="text">{{ goodsitem.goods_title }}</p>
                  <!-- <img @click="showdeletedialog(1, goodsitem)" src="../../../assets/cart/delete_0.svg" alt="" /> -->
                </div>
                <!-- 商品规格 -->
                <div class="Commodityspecification">
                  <p>{{ goodsitem.text }}</p>

                  <!-- <img src="../../../assets/cart/expansion.svg" alt="" /> -->
                </div>
                <!-- 价格 -->
                <div class="price">
                  <span class="dollar">
                    ${{
                      $fun.EURNumSegmentation(
                        $fun.ceil(goodsitem.price * $store.state.exchangeRate)
                      )
                    }}
                  </span>
                  <span class="RMB">
                    (￥{{ $fun.RMBNumSegmentation(goodsitem.price) }})
                  </span>
                </div>
              </div>
            </div>

            <!-- 总价 -->
            <div class="totalprice">
              <div class="left-price">
                <span class="title">{{ $fanyi("总价") }}:</span>
                <!-- <span class="dollar"> $3.03( 21.00¥)</span> -->
                <span class="dollar">
                  ${{
                    $fun.EURNumSegmentation(
                      $fun.ceil(
                        goodsitem.price *
                        goodsitem.num *
                        $store.state.exchangeRate
                      )
                    )
                  }}
                </span>

                <span class="RMB">
                  (￥{{
                    $fun
                      .RMBNumSegmentation(goodsitem.price * goodsitem.num)
                      .toFixed(2)
                  }})
                </span>
              </div>
              <!-- <div class="right-input">
                <van-stepper v-model="goodsitem.num" :min="1" integer />
              </div> -->
              <div class="rightnum">
                x{{ goodsitem.num }}
              </div>
            </div>
            <!-- 备注 -->
            <div class="Remarks">
              <input :disabled="true" type="text" :placeholder="$fanyi('备注栏')" v-model="goodsitem.user_postscript" />
            </div>
          </div>


        </div>
        <!-- 购物车空 -->

        <div class="nodata" v-if="cartlist.length == 0">
          <div class="img-box">
            <img src="../../../assets/defaulticon/sssb.svg" alt="">
          </div>
          <p>{{ $fanyi('购物车为空') }}</p>
        </div>
      </div>
      <!-- 商品库 -->
      <div class="shopku" v-else>
        <!-- 列表 -->

        <div v-if="inventorylist.length > 0">
          <!-- 商品信息 -->
          <div class="gooditem" :class="{ borderbottom: index != 0 }" v-for="(goodsitem, index) in inventorylist"
            :key="goodsitem.goods_id">
            <div class="Content">
              <!--复选框 -->
              <input class="checkbox-box" @change="inventorycheckchange(item)" type="checkbox"
                v-model="goodsitem.checked" />
              <!-- 图片 -->
              <div class="img-box" @click="$fun.toCommodityDetails({
                goods_id: goodsitem.goods_id,
                shop_type: goodsitem.shop_type,
              }
              );">
                <van-image :src="goodsitem.pic">
                  <template v-slot:loading>
                    <van-loading type="spinner" size="20" />
                  </template>
                </van-image>
              </div>
              <!--右侧商品信息  -->
              <div class="rightgoodsinfo">
                <!-- 商品描述和删除 -->
                <div class="Description">
                  <p class="text">{{ goodsitem.goods_title }}</p>
                  <!-- <img @click="showdeletedialog(1, goodsitem)" src="../../../assets/cart/delete_0.svg" alt="" /> -->
                </div>
                <!-- 商品规格 -->
                <div class="Commodityspecification">
                  <p>{{ goodsitem.text }}</p>

                  <!-- <img src="../../../assets/cart/expansion.svg" alt="" /> -->
                </div>
                <!-- 价格 -->
                <div class="price">
                  <span class="dollar">
                    ${{
                      $fun.EURNumSegmentation(
                        $fun.ceil(goodsitem.price * $store.state.exchangeRate)
                      )
                    }}
                  </span>
                  <span class="RMB">
                    (￥{{ $fun.RMBNumSegmentation(goodsitem.price) }})
                  </span>
                </div>
              </div>
            </div>

            <!-- 总价 -->
            <div class="totalprice">
              <div class="left-price">
                <span class="title">{{ $fanyi("总价") }}:</span>
                <!-- <span class="dollar"> $3.03( 21.00¥)</span> -->
                <span class="dollar">
                  ${{
                    $fun.EURNumSegmentation(
                      $fun.ceil(
                        goodsitem.price *
                        goodsitem.num *
                        $store.state.exchangeRate
                      )
                    )
                  }}
                </span>

                <span class="RMB">
                  (￥{{
                    $fun
                      .RMBNumSegmentation(goodsitem.price * goodsitem.num)
                      .toFixed(2)
                  }})
                </span>
              </div>
              <!-- <div class="right-input">
                <van-stepper v-model="goodsitem.num" :min="1" integer />
              </div> -->
              <div class="rightnum">
                x{{ goodsitem.num }}
              </div>
            </div>
            <!-- 备注 -->
            <div class="Remarks">
              <input :disabled="true" type="text" :placeholder="$fanyi('备注栏')" v-model="goodsitem.user_postscript" />
            </div>
          </div>


        </div>
        <!-- 商品库为空 -->

        <div class="nodata" v-if="inventorylist.length == 0">
          <div class="img-box">
            <img src="../../../assets/defaulticon/sssb.svg" alt="">
          </div>
          <p>{{ $fanyi('商品库为空') }}</p>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="Bottomoperationbar">
      <div class="allchecked">
        <div class="all">
          <!-- 购物车全选 -->
          <input v-if="active == 1" class="checkbox-box" @change="allcheckedchange(1)" type="checkbox"
            v-model="allcheckedcart" />
          <!-- 商品库全选 -->
          <input v-else class="checkbox-box" @change="allcheckedchange(2)" type="checkbox" v-model="allcheckedshop" />
          <span>{{ $fanyi("全选/取消") }}</span>
        </div>

        <!-- 数量 -->
        <div class="shuliang">
          {{ $fanyi("数量总计") }}: <span v-if="active == 1">{{ commoditytotalcart }}</span> <span v-else>{{
            commoditytotalshop
          }}</span>
        </div>
      </div>
      <div class="caoziolan">
        <!--  提出购物车样式 -->
        <div class="tichubox">
          <div class="left-prce">
            <span class="title">{{ $fanyi("总价") }}:</span>
            <div class="price" v-if="active == 1">
              <p class="dollar">
                $
                {{
                  $fun.EURNumSegmentation(
                    $fun.ceil(totalPricecart * $store.state.exchangeRate)
                  )
                }}
              </p>
              <p class="REM">￥{{ $fun.RMBNumSegmentation(totalPricecart) }}</p>
            </div>
            <div class="price" v-else>
              <p class="dollar">
                $
                {{
                  $fun.EURNumSegmentation(
                    $fun.ceil(totalPriceshop * $store.state.exchangeRate)
                  )
                }}
              </p>
              <p class="REM">￥{{ $fun.RMBNumSegmentation($fun.ceil(totalPriceshop)) }}</p>
            </div>
          </div>
          <div class="tichu" @click="addorder">{{ $fanyi("添加至订单") }}</div>
        </div>


      </div>
    </div>
  </van-popup>
</template>
<script setup>
import { getCurrentInstance, ref, defineExpose, defineEmits } from 'vue'

const { proxy } = getCurrentInstance()
console.log(proxy);

const showBottom = ref(false)// 控制弹层显示
const active = ref(1)// 默认购物车

const cartlist = ref([])// 购物车数据列表
const inventorylist = ref([])// 商品库数据列表

const allcheckedcart = ref() // 全选 购物车
const allcheckedshop = ref() // 全选 商品库
const totalPricecart = ref(0) // 购物车商品总价
const totalPriceshop = ref(0) // 商品库商品总价
const commoditytotalcart = ref(0)//购物车数量总数
const commoditytotalshop = ref(0) // 商品库商品总数
const shoptype = ref('cart') // cart 购物车 产品库 inventory
const cartids = ref('')
const notinventoryidarr = ref([])

const open = (ids) => {
  cartids.value = ids

  getorderAddGoodsList()

  showBottom.value = true

}
// 获取数据添加订单数据
const getorderAddGoodsList = async () => {

  let data = {
    type: shoptype.value,
    page: 1,
    pageSize: 99,

  }
  if (shoptype.value == "cart") {
    data.not_cart_id = cartids.value
  } else {

    data.not_inventory_id = notinventoryidarr.value.join(",")
  }

  const res = await proxy.$api.orderAddGoodsList(data)
  if (res.code !== 0) {
    return
  }
  if (shoptype.value == "cart") {

    cartlist.value = res.data
    console.log(cartlist.value);
    Processingdata(1)

  } else {
    inventorylist.value = res.data
    Processingdata(2)
  }




}
const emit = defineEmits(['addData'])
//  处理数据

const Processingdata = (active) => {
  // 1 购物车
  if (active == 1) {
    commoditytotalcart.value = 0
    totalPricecart.value = 0
    cartlist.value.forEach((i) => {
      commoditytotalcart.value += i.num
      if (i.checked) {
        totalPricecart.value += Number(i.price) * Number(i.num);
      }

      i.text = ''
      i.detail.forEach((detailitem) => {
        i.text += detailitem.key + ":" + " " + detailitem.value + " ";
      });
    })
    // console.log(cartlist.value.every((ind) => ind.checked == true));
    if (cartlist.value.length > 0) {
      allcheckedcart.value = cartlist.value.every((ind) => ind.checked == true)
    }

  }
  else {
    totalPriceshop.value = 0
    commoditytotalshop.value = 0
    inventorylist.value.forEach((i) => {
      commoditytotalshop.value += i.num
      if (i.checked) {
        totalPriceshop.value += Number(i.price) * Number(i.num);
      }

      i.text = ''
      i.detail.forEach((detailitem) => {
        i.text += detailitem.key + ":" + " " + detailitem.value + " ";
      });
    })
    if (inventorylist.value.length > 0) {
      allcheckedshop.value = inventorylist.value.every((ind) => ind.checked == true)
    }

  }
}
// 购物车单选
const cartcheckchange = () => {
  Processingdata(1)
}
// 弹窗关闭
const close = () => {
  if (shoptype.value == "cart") {
    cartlist.value = []
  } else {
    inventorylist.value = []
  }


}
// 商品库单选
const inventorycheckchange = () => {
  Processingdata(2)
}
// 全选
const allcheckedchange = (active) => {
  // active 1 购物车 2 商品库
  console.log(active);
  if (active == 1) {
    cartlist.value.forEach((i) => {
      i.checked = allcheckedcart.value
    })
    Processingdata(1)
  } else {
    inventorylist.value.forEach((i) => {
      i.checked = allcheckedshop.value
    })
    Processingdata(2)
  }
}
// 添加到订单触发
const addorder = () => {
  // 开始循环判断 如果是同一家商品放到一起
  if (shoptype.value == "cart") {
    let addData = {
      newList: [],
    };
    // let goodsNum = 0;
    cartlist.value.forEach((goodsItem) => {
      if (goodsItem.checked) {
        // 计算追加的商品数量
        // goodsNum++;
        if (
          !!addData.newList.filter(
            (item) => item.shop_name == goodsItem.shop_name
          ).length == 0
        ) {
          addData.newList.push({
            shop_id: goodsItem.shop_id,
            shop_name: goodsItem.shop_name,
            list: [],
          });
        }
      }
    });

    cartlist.value.forEach((goodsItem) => {

      if (goodsItem.checked) {
        addData.newList.forEach((items) => {
          if (goodsItem.shop_id == items.shop_id) {
            items.list.push(goodsItem);
          }
        });
      }
    });
    let obj = {}

    addData.newList.reduce((item, next) => {
      obj[next.shop_id] ? '' : obj[next.shop_id] = true && item.push(next)
      return item
    }, [])
    console.log(addData);
    emit('addData', addData)
    showBottom.value = false

  } else {

    let addData = {
      newList: [],
    };
    // let goodsNum = 0;
    inventorylist.value.forEach((goodsItem) => {
      if (goodsItem.checked) {
        // 计算追加的商品数量
        // goodsNum++;
        notinventoryidarr.value.push(goodsItem.inventory_id)
        if (
          !!addData.newList.filter(
            (item) => item.shop_name == goodsItem.shop_name
          ).length == 0
        ) {
          addData.newList.push({
            shop_id: goodsItem.shop_id,
            shop_name: goodsItem.shop_name,
            list: [],
          });
        }
      }
    });

    inventorylist.value.forEach((goodsItem) => {


      if (goodsItem.checked) {
        addData.newList.forEach((items) => {
          if (goodsItem.shop_id == items.shop_id) {
            items.list.push(goodsItem);
          }
        });
      }
    });
    let obj = {}

    addData.newList.reduce((item, next) => {
      obj[next.shop_id] ? '' : obj[next.shop_id] = true && item.push(next)
      return item
    }, [])
    console.log(addData);
    emit('addData', addData)
    showBottom.value = false

  }



}
defineExpose({
  open
})
</script>
<style lang="scss">
#additiveproduct {
  min-height: 370px;

  max-height: 88%;

  background: #FFFFFF;
  border-radius: 8px 8px 0px 0px;



  .top-box {
    position: sticky;
    top: 0px;
    z-index: 2000;
    width: 100%;
    background: #F6F6F6;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    height: 44px;

    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    padding: 0 20px;
    line-height: 24px;
    align-items: center;

    .title {

      display: flex;

      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        margin-right: 30px;
      }

      .active {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #FF730B;
        line-height: 24px;
      }


    }

    .van-icon-cross {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      color: #222222;
      font-weight: 600;
      font-size: 16px;

      // top: 14px;

    }
  }

}
</style>
<style lang='scss' scoped='scoped'>
@import "@/style/scss/mixin.scss";

// 选择框样式
.checkbox-box {


  width: 12px;
  height: 12px;
  padding: 0px;
  margin: 0px;
  border-radius: 2px;
  border: 1px solid #dedede;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-right: 5px;

  border: 1px solid #ccc;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  position: relative;
}

input[type="checkbox"]:checked {
  background: #ff730b;
  border-color: #ff730b;
  border: 1px solid#ff730b;
}

input[type="checkbox"]::before {
  position: absolute;
  top: -2px;
  left: -1px;
  content: "\2713";
  /* Unicode编码，表示对号 */
  display: inline-block;

  width: 12px;
  height: 12px;

  text-align: center;
  font-size: 14px;
  opacity: 0;
  color: #ffffff;
  /* 对号的颜色 */
  font-weight: bold;
  transform: scale(0.8, 0.5);
  /* 缩放 */
  transition: transform 0.2s ease-in-out;
  /* 缩放过渡效果 */
}

input[type="checkbox"]:checked::before {
  opacity: 1;
}

// 购物车
.cart {
  width: 100%;


}



.cart,
.shopku {
  padding: 10px;
  padding-bottom: 120px;

  .gooditem {
    width: 100%;
    height: 200px;
    padding-top: 15px;
    border: 0.5px solid #E2E2E2;
    width: 100%;
    margin-bottom: 10px;
    border-radius: 6px;
    padding: 15px;

    .Content {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      margin-bottom: 5px;

      .img-box {
        margin-left: 10px;
        width: 80px;
        height: 80px;
        margin-right: 10px;
        border-radius: 4px;

        :deep().van-image {
          width: 80px;
          height: 80px;
          border-radius: 4px;
        }

        :deep().van-image__img {
          border-radius: 4px;
        }
      }

      .rightgoodsinfo {
        flex: 1;
        height: 100%;

        // 描述
        .Description {
          height: 32px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
          align-items: center;

          .text {
            height: 32px;
            font-size: 12px;
            font-family: ArialMT;
            color: #222222;
            line-height: 16px;
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          img {
            width: 24px;
            height: 24px;
            margin-left: 10px;
          }
        }

        .Commodityspecification {
          padding: 0 5px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          width: 200px;
          height: 20px;
          background: #f6f6f6;
          border-radius: 4px;
          margin-bottom: 5px;

          p {
            align-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            // zoom: 0.9;
            font-size: 12px;
            font-family: ArialMT;
            color: #666666;
            line-height: 22px;
            zoom: 0.9;
          }

          img {
            margin-left: 10px;
            width: 8px;
            height: 4px;
          }
        }

        .price {
          height: 18px;
          font-size: 12px;
          font-family: ArialMT;
          color: #222222;
          line-height: 18px;

          .dollar,
          .RMB {
            font-size: 12px;
            font-family: ArialMT;
            color: #222222;
            line-height: 18px;
          }
        }
      }
    }

    // 总价
    .totalprice {
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .left-price {
        display: flex;
        align-items: center;
        height: 30px;

        .title {
          height: 18px;
          font-size: 12px;
          font-family: ArialMT;
          color: #222222;
          line-height: 16px;
          display: flex;
          margin-right: 5px;
        }

        .dollar {
          margin-right: 2px;
        }

        .dollar,
        .RMB {
          height: 18px;
          font-size: 12px;
          font-family: Arial-BoldMT, Arial;
          font-weight: 500;
          color: #ff730b;
          line-height: 18px;
        }
      }

      .right-input {
        width: 100px;
        height: 30px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #222222;
        display: flex;
        align-items: center;
        justify-content: center;

        :deep().van-haptics-feedback {
          width: 22px;
          height: 22px;
          background: #f2f2f2;
          border-radius: 2px;
        }

        :deep().van-stepper__minus--disabled {
          width: 22px;
          height: 22px;
          background: #f2f2f2;
          border-radius: 2px;
        }

        :deep().van-stepper {
          height: 22px;
          display: flex;
          align-items: center;
        }

        :deep().van-stepper__input {
          width: 40px;
          height: 16px;
          font-size: 12px;

          font-family: ArialMT;
          background-color: #fff;
        }
      }

      .rightnum {
        font-size: 12px;
        font-weight: 500;
      }
    }

    // 备注

    .Remarks {
      // width: 325px;
      // height: 40px;
      // background: #FFFFFF;
      // border-radius: 6px;
      // border: 1px solid #DEDEDE;

      input {
        width: 325px;
        height: 40px;
        background: #ffffff;
        border-radius: 6px;
        border: 0.5px solid #dedede;
        font-size: 12px;
        font-family: ArialMT;
        padding-left: 10px;
        line-height: 18px;
      }

      input:placeholder {
        font-size: 12px;
        font-family: ArialMT;
        color: #C0C4CC;
      }
    }
  }

  .nodata {
    width: 100%;
    height: 218px;




    .img-box {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 40px;
      margin-bottom: 20px;
    }

    img {
      margin: auto;
      width: 80px;
      height: 80px;


    }

    p {
      width: 100%;
      text-align: center;
      margin: auto;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }
  }

}

// 商品库
.shopku {
  width: 100%;


}

// 底部价格栏
.Bottomoperationbar {
  position: fixed;
  bottom: 0px;
  width: 100%;
  background: #ffffff;

  height: 108px;

  .allchecked {
    padding: 0 20px;
    height: 40px;
    display: flex;
    background: #ffffff;
    box-shadow: inset 0px 0.5px 0px 0px #e2e2e2;
    justify-content: space-between;

    .fanshu {
      display: flex;
      align-items: center;
      height: 100%;

      font-size: 10px;
      font-family: ArialMT;
      color: #666666;
      line-height: 16px;
      zoom: 0.9;

      span {
        display: flex;
        margin-left: 2px;
        color: #222222;
        font-weight: 600;
      }
    }

    .shuliang {
      display: flex;
      align-items: center;
      height: 16px;
      font-size: 12px;
      font-family: ArialMT;
      color: #666666;
      line-height: 16px;
      height: 100%;
      zoom: 0.9;

      span {
        display: flex;
        margin-left: 2px;
        color: #222222;
        font-weight: 600;
      }
    }

    .all {
      display: flex;
      align-items: center;
      height: 100%;
      flex: 0 0 130px;

      span {
        display: flex;

        font-size: 12px;
        font-family: ArialMT;
        zoom: 0.9;
        color: #666666;
        // line-height: 20px;
      }
    }
  }

  .caoziolan {
    padding: 0 20px;
    height: 68px;
    background: #ffffff;
    box-shadow: inset 0px 0.5px 0px 0px #e2e2e2;

    // 提出
    .tichubox {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tichu {
        width: 160px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: ArialMT;
        color: #ffffff;
        line-height: 20px;
        background: #ff730b;
        border-radius: 6px;
      }

      .left-prce {
        height: 100%;
        display: flex;
        padding-top: 15px;

        .title {
          display: flex;
          min-width: 60px;
          height: 20px;
          font-size: 12px;
          font-family: ArialMT;
          color: #666666;
          margin-right: 5px;
        }

        .price {
          height: 100%;

          .dollar {
            height: 20px;
            font-size: 14px;
            font-family: Arial-BoldMT, Arial;
            font-weight: normal;
            color: #ff730b;
            line-height: 20px;
          }

          .REM {
            height: 16px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 16px;
          }
        }
      }
    }

    // 编辑
    .bianjibox {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .delete {
        width: 160px;
        height: 48px;
        background: #608bff;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        align-items: center;
      }

      .MoveintoCollection {
        width: 160px;
        height: 48px;
        background: #ff730b;
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>